import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'gatsby-image';

import { fadeIn } from '../constants/keyframes';
import { TRANSITION_TIME_ENTER, TRANSITION_TIME_TOTAL } from '../constants/transitions';
import { fluidPropTypes } from '../types';

import GrayImage from './GrayImage';


const ImageOuterWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const AnimatedGrayImage = styled(GrayImage)`
  opacity: 0;
  will-change: opacity;
  ${(props) => (props.loaded ? `animation: ${fadeIn} .6s linear ${TRANSITION_TIME_TOTAL}ms forwards` : '')};
`;

const ImageWrapperColor = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  opacity: 0;
  transition: opacity .2s;
  will-change: opacity;

  &:hover {
    opacity: 1;
  }
`;

class DuoToneImage extends Component {
  constructor(props) {
    super(props);

    this.show = this.show.bind(this);
    setTimeout(() => {
      this.setState({
        ready: true,
      });
    }, TRANSITION_TIME_ENTER);

    this.state = {
      numberLoaded: 0,
      ready: false,
    };
  }

  show() {
    this.setState((prevState) => ({
      numberLoaded: prevState.numberLoaded + 1,
    }));
  }

  render() {
    const { image, style } = this.props;
    const { numberLoaded, ready } = this.state;
    const loaded = numberLoaded === 2;

    return (
      <If condition={ready}>
        <ImageOuterWrapper loaded={loaded}>
          <AnimatedGrayImage loaded={loaded}>
            <Img key={image.id} fluid={image.fluid} onLoad={this.show} style={style} />
          </AnimatedGrayImage>
          <ImageWrapperColor loaded={loaded}>
            <Img key={image.id} fluid={image.fluid} onLoad={this.show} style={style} />
          </ImageWrapperColor>
        </ImageOuterWrapper>
      </If>
    );
  }
}

DuoToneImage.propTypes = {
  image: PropTypes.shape({
    id: PropTypes.string,
    fluid: fluidPropTypes,
  }).isRequired,
  style: PropTypes.object,
};

export default DuoToneImage;
